import React, {FC} from 'react';
import {Badge} from './GenericBadges';

interface Props {
  dataTestId: string;
  text: string;
}

export const UpcyclingBadge: FC<Props> = ({dataTestId, text}) => {
  return (
    <Badge
      text={text}
      dataTestId={dataTestId}
      emoji="♻️"
      disableRoundedCorners
    />
  );
};
